import { TxDocument } from '../model/document.model';
import { Transaction } from '../model/transaction.model';
import { checkMustReadRelation, checkMustSignRelation } from './client-doc-relation.util';

export function isReadyToProcessDocument(
  document: TxDocument,
  transaction: Transaction,
  clientId: string
): boolean {
  return (
    (!checkMustSignRelation(document, clientId) && !checkMustReadRelation(document, clientId)) ||
    transaction.hasClientFinishedAllPreviousSteps(document.id, clientId)
  );
}
